import http from '@/libs/axios'

export function getSystemMonitor() {
  return http({
    url: `/os_info/system_information/`,
    method: 'GET',
  })
}
